module.exports = __webpack_public_path__ + "static/img/active_vip_05.a7fce75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_vip_05.jpg
// module id = Bu/B
// module chunks = 0